import { cva } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import { MessageStatus } from '../types';

interface Props {
    status: MessageStatus;
    messageId?: number;
}
const badgeStyles = cva('tw-py-1 tw-px-3 tw-text-xs tw-rounded-lg tw-w-fit', {
    variants: {
        status: {
            CREATED: 'tw-bg-accents-1 tw-text-accents-8',
            SEND: 'tw-bg-successLight tw-text-success',
            REJECT: 'tw-bg-error tw-text-white',
            DELIVERY: 'tw-bg-success tw-text-white',
            BOUNCE: 'tw-bg-error tw-text-white',
            DELIVERY_DELAY: 'tw-bg-warning tw-text-white',
            COMPLAINT: 'tw-bg-error tw-text-white',
            OPEN: 'tw-bg-success tw-text-white',
            CLICK: 'tw-bg-success tw-text-white'
        }
    },
    defaultVariants: {
        status: 'CREATED'
    }
});

export const StatusBadge = ({ status }: Props) => {
    const { t } = useTranslation('message-management');
    const currentStatus = status?.status || 'CREATED';

    return <div className={badgeStyles({ status: currentStatus })}>{t(`type.${currentStatus}`)}</div>;
};
